export function getTimeString(date: Date, language: string) {
  switch (language) {
    case 'en-GB':
    case 'en-US':
      return createTwelveHourNotationInEn(date);
    case 'ja-JP':
      return createTwelveHourNotationInJp(date);
    case 'ko-KR':
      return createTwelveHourNotationInKr(date);
    case 'de-DE':
    case 'es-ES':
    case 'es-US':
    case 'fr-CA':
    case 'fr-FR':
    case 'it-IT':
    case 'nl-NL':
    case 'ru-RU':
    case 'zh-CN':
    case 'zh-TW':
    default:
      return createTwentyFourHourNotation(date);
  }
}

function createTwentyFourHourNotation(date: Date) {
  const hourString = date.getHours().toString();
  const minuteString = date
    .getMinutes()
    .toString()
    .padStart(2, '0');

  return hourString + ':' + minuteString;
}

function createTwelveHourNotationInEn(date: Date) {
  const hours = date.getHours();
  const suffix = hours < 12 ? 'AM' : 'PM';

  let hourString: string;
  if (hours === 0 || hours === 12) {
    hourString = '12';
  } else {
    hourString = (hours % 12).toString();
  }
  const minuteString = date
    .getMinutes()
    .toString()
    .padStart(2, '0');

  return hourString + ':' + minuteString + ' ' + suffix;
}

function createTwelveHourNotationInJp(date: Date) {
  const hours = date.getHours();
  const prefix = hours < 12 ? 'AM' : 'PM';
  const hourString = (hours % 12).toString();

  const minuteString = date
    .getMinutes()
    .toString()
    .padStart(2, '0');

  return prefix + ' ' + hourString + ':' + minuteString;
}

function createTwelveHourNotationInKr(date: Date) {
  const hours = date.getHours();
  const prefix = hours < 12 ? 'AM' : 'PM';

  let hourString: string;
  if (hours === 12) {
    hourString = '12';
  } else {
    hourString = (hours % 12).toString().padStart(2, '0');
  }

  const minuteString = date
    .getMinutes()
    .toString()
    .padStart(2, '0');

  return prefix + ' ' + hourString + ':' + minuteString;
}
